import { useEffect, useState } from "react";
import { Search as SearchIcon, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";
import { UserChip } from "@/components/UserChip";

export default function Search() {
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (q.trim().length < 2) { setRes(null); return; }
    setLoading(true);
    const t = setTimeout(() => api.get("/users/search", { params: { q } }).then((r) => setRes(r.data)).finally(() => setLoading(false)), 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="mx-auto max-w-2xl space-y-5 py-6" data-testid="search-page">
      <h1 className="text-3xl font-extrabold tracking-tight">Buscar perfis</h1>
      <div className="relative">
        <SearchIcon size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome de pessoa, igreja ou paróquia" className="h-12 rounded-full bg-white/5 pl-11 text-base" data-testid="search-input" />
        {loading && <Loader2 size={16} className="absolute right-4 top-1/2 -translate-y-1/2 animate-spin text-muted-foreground" />}
      </div>
      {!res && <p className="text-sm text-muted-foreground">Digite pelo menos 2 letras. As instituições verificadas aparecem primeiro.</p>}
      {res?.length === 0 && <p className="py-10 text-center text-sm text-muted-foreground" data-testid="search-empty">Nenhum perfil encontrado.</p>}
      <div className="space-y-1" data-testid="search-results">{res?.map((u) => <UserChip key={u.id} u={u} />)}</div>
    </div>
  );
}
